<template>
    <div>
        <v-navigation-drawer
            v-model="rightDrawer"
            app
            temporary
            right
            width="400"
        >
            <v-toolbar dense dark color="blue darken-2" flat>
                <v-toolbar-title>Filtre</v-toolbar-title>
            </v-toolbar>
            <v-container fluid>
                <slot name="filter"></slot>
            </v-container>
        </v-navigation-drawer>


        <v-container fluid>
            <v-card elevation="5">
                <v-toolbar class="mb-2" height="35">
                    <v-toolbar-title>
                        {{ title }}
                        <v-icon
                            v-if="titleIcon"
                            :color="titleColor"
                            left
                        >
                            {{ titleIcon }}
                        </v-icon>
                        <v-chip
                            v-if="total !== null && total !== undefined"
                            small
                            outlined
                        >
                            <strong>Total: {{ total }}</strong>
                        </v-chip>
                    </v-toolbar-title>
                    <v-divider vertical class="mr-1 ml-1"/>
                    <str-filter-button
                        v-if="showFilter"
                        :filter="filter"
                        @press="rightDrawer = true"
                    />
                    <v-btn
                        v-if="showFilter"
                        depressed
                        class="ml-2 white--text"
                        color="red"
                        small
                        @click="clearFilter"
                    >
                        Mise à blanc
                        <v-icon right dark>mdi-trash-can</v-icon>
                    </v-btn>
                    <slot name="leftToolbar"></slot>
                    <v-spacer/>
                    <slot name="rightToolbar"></slot>
                </v-toolbar>
                <slot name="content"></slot>
            </v-card>
        </v-container>
    </div>
</template>

<script>

import StrFilterButton from "@/components/StrFilterButton.vue";
import useSharedData from "@/use/SharedData";

export default {
    name: "WApp",
    props: {
        title: String,
        titleIcon: String,
        titleColor: String,
        total: [Number, String],
        showFilter: Boolean,
        filter: {
            type: Object,
            defaultValue: {}
        },
    },
    components: {StrFilterButton},
    emits: ["clearFilter"],
    setup(props, {emit}) {
        const {rightDrawer} = useSharedData();

        function clearFilter() {
            emit("clearFilter");
        }

        return {
            rightDrawer,
            clearFilter
        };
    }
}
</script>

<style scoped>

</style>